import React from 'react';

const AboutAutomoose = () => (
  <>
    <h5 className="text-xl mt-8 mb-4">
      About Autonomoose
    </h5>
    <p>
      The Autonomoose is an autonomous vehicle platform created as a joint effort between the
      Toronto Robotics and AI Laboratory (TRAIL) and Waterloo Intelligent Systems Engineering Lab
      (WISE Lab) at the University of Waterloo. This platform has enabled us to test various
      software modules to autonomously drive on public roads.
    </p>
  </>
);

export default AboutAutomoose;
